import { useMutation } from '@apollo/client';

import { UpdateJobPreferencesUserFlagDocument } from '@xing-com/crate-jobs-graphql';

import type {
  UpdateJobPreferencesUserFlagMutationParams,
  UseUpdateJobPreferencesUserFlag,
} from './types';

const DEFAULT_PARAMS = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onError: (): void => {},
};

export const useUpdateJobPreferencesUserFlag = (
  params?: UpdateJobPreferencesUserFlagMutationParams
): UseUpdateJobPreferencesUserFlag => {
  const { onError } = {
    ...DEFAULT_PARAMS,
    ...(params ?? {}),
  };

  const [updateUserFlagsX1] = useMutation(UpdateJobPreferencesUserFlagDocument);

  return ({ onCompleted, serpBannerHidden }) => {
    updateUserFlagsX1({
      variables: { input: { serpBannerHidden } },
      onCompleted: (response) => {
        if (
          response.jobPreferenceUserFlags?.__typename ===
          'UpdateJobPreferenceUserFlagsError'
        ) {
          onError();
        }

        onCompleted?.(response);
      },
      onError,
    });
  };
};
